module.exports = __webpack_public_path__ + "img/clubsaway-logo-mobile.06cc3666.svg";